(function () {
  'use strict';

  const originalOptions = new WeakMap();

  function boot() {
    document.querySelectorAll('variant-selects').forEach(initElement);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'VARIANT-SELECTS') initElement(node);
          if (node.querySelectorAll) {
            node.querySelectorAll('variant-selects').forEach(initElement);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initElement(el) {
    if (el.dataset.dropdownFilterInit === 'true') return;
    el.dataset.dropdownFilterInit = 'true';

    const jsonScript = el.querySelector('script[type="application/json"]');
    if (!jsonScript) return;

    let variants;
    try {
      variants = JSON.parse(jsonScript.textContent);
    } catch (e) {
      console.warn('[variant-dropdown-filter] Failed to parse variant JSON:', e);
      return;
    }

    const selects = Array.from(el.querySelectorAll('select[name^="options["]'));
    if (selects.length < 2) return;

    selects.forEach(function (select) {
      originalOptions.set(
        select,
        Array.from(select.options).map(function (opt) {
          return { value: opt.value, text: opt.text };
        })
      );
    });

    selects.forEach(function (select, index) {
      select.addEventListener('change', function (e) {
        if (e._fromFilter) return;
        filterDownstream(selects, index, variants, el);
      });
    });

    filterDownstream(selects, 0, variants, el);
  }

  function filterDownstream(selects, changedIndex, variants, variantSelectsEl) {
    const selections = selects.map(function (s) { return s.value; });

    for (let i = changedIndex + 1; i < selects.length; i++) {
      const select = selects[i];
      const previousValue = select.value;

      const validValues = getValidValues(i, selections.slice(0, i), variants);
      rebuildSelect(select, validValues, previousValue);
      selections[i] = select.value;

      // Fire silent synthetic events on downstream selects (don't trigger onVariantChange)
      const evt = new Event('change', { bubbles: true });
      evt._fromFilter = true;
      select.dispatchEvent(evt);
    }

    // Fire ONE real change event on the variant-selects ELEMENT (not a child select)
    // so onVariantChange reads all selects together as a complete combination
    const finalEvt = new Event('change', { bubbles: true });
    variantSelectsEl.dispatchEvent(finalEvt);
  }

  function getValidValues(position, selectedBefore, variants) {
    const valid = new Set();

    variants.forEach(function (variant) {
      for (let i = 0; i < selectedBefore.length; i++) {
        if (variant.options[i] !== selectedBefore[i]) return;
      }
      if (variant.options[position] !== undefined) {
        valid.add(variant.options[position]);
      }
    });

    return valid;
  }

  function rebuildSelect(select, validValues, previousValue) {
    const originals = originalOptions.get(select) || [];

    while (select.options.length > 0) select.remove(0);

    originals.forEach(function (orig) {
      if (!validValues.has(orig.value)) return;
      const opt = document.createElement('option');
      opt.value = orig.value;
      opt.text = orig.text;
      select.appendChild(opt);
    });

    const previousStillValid = Array.from(select.options).some(function (o) {
      return o.value === previousValue;
    });

    select.value = previousStillValid
      ? previousValue
      : (select.options[0] ? select.options[0].value : '');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();